import { jsx } from "react/jsx-runtime";
import WorkspacePremiumIcon from "@mui/icons-material/WorkspacePremium";
import { validateTidalLicense } from "../../base/index.js";
function WorkspacePremium(props) {
  return /* @__PURE__ */ jsx(
    WorkspacePremiumIcon,
    {
      "data-testid": "WorkspacePremium",
      ...props,
      "data-tidal": "TidalIcon",
      "data-tidal-icon": "WorkspacePremium",
      "data-tidal-icon-meta": "miscellaneous"
    }
  );
}
WorkspacePremium.tidalIconMeta = {
  categories: "miscellaneous",
  name: "WorkspacePremium"
};
validateTidalLicense();
export {
  WorkspacePremium
};
//# sourceMappingURL=WorkspacePremium.js.map
